import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { SettingsUserProfile } from './settings-user-profile';

// No `resource_key` / `canActivate`: every authenticated user manages their
// own profile. `ResourceAccessGuard` redirects when `resourceKey` is missing
// (resource-access.guard.ts), so we deliberately omit it here.
export function provideSettingsElementUserProfile(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'profile',
        name: 'Your Profile',
        icon: 'pi pi-user',
        component: SettingsUserProfile,
        // Sits last under "Other" — explicit high order so future additions
        // slot in above it without further re-ordering.
        order: 99,
        translateName: 'SETTINGS.USER_PROFILE.TITLE',
        category: {
          id: 'other',
          name: 'Other',
          order: 3,
          translateName: 'SETTINGS.CATEGORIES.OTHER',
        },
      },
      multi: true,
    },
  ]);
}
